module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_3009.8b4702dd.png";